import { STATICINFOS_SERVICE } from "@/services/staticInfos.service.js";

const state = {getStaticInfosOutput: {}, postStaticInfoOutput: false, putStaticInfoOutput: false, putStaticInfoByStatusOutput: false, getStaticInfoByIDOutput: {}, getStaticInfoBySlugOutput: {}};

const actions = {
    //Service to get static infos
    getStaticInfos({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getStaticInfosRequest');

        STATICINFOS_SERVICE.getStaticInfos(queryParams)
            .then(
                output => {
                    commit('getStaticInfosSuccess', output);
                },
                error => {
                    commit('getStaticInfosFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create static infos
    postStaticInfo({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postStaticInfoRequest');

        STATICINFOS_SERVICE.postStaticInfo(input)
            .then(
                output => {
                    commit('postStaticInfoSuccess', output);
                },
                error => {
                    commit('postStaticInfoFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update static info
    putStaticInfo({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putStaticInfoRequest');

        STATICINFOS_SERVICE.putStaticInfo(input)
            .then(
                output => {
                    commit('putStaticInfoSuccess', output);
                },
                error => {
                    commit('putStaticInfoFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update status
    putStaticInfoByStatus({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putStaticInfoByStatusRequest');

        STATICINFOS_SERVICE.putStaticInfoByStatus(input)
            .then(
                output => {
                    commit('putStaticInfoByStatusSuccess', output);
                },
                error => {
                    commit('putStaticInfoByStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get static info details
    getStaticInfoByID({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getStaticInfoByIDRequest');

        STATICINFOS_SERVICE.getStaticInfoByID(id)
            .then(
                output => {
                    commit('getStaticInfoByIDSuccess', output);
                },
                error => {
                    commit('getStaticInfoByIDFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get static info details
    getStaticInfoBySlug({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getStaticInfoBySlugRequest');

        STATICINFOS_SERVICE.getStaticInfoBySlug(queryParams)
            .then(
                output => {
                    commit('getStaticInfoBySlugSuccess', output);
                },
                error => {
                    commit('getStaticInfoBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getStaticInfos
    getStaticInfosRequest(state) {
    },
    getStaticInfosSuccess(state, output) {
        state.getStaticInfosOutput = output;
    },
    getStaticInfosFailure(state) {
        state.getStaticInfosOutput = false;
    },

    //postStaticInfo
    postStaticInfoRequest(state) {
        state.postStaticInfoOutput = null;
    },
    postStaticInfoSuccess(state, output) {
        state.postStaticInfoOutput = true;
    },
    postStaticInfoFailure(state) {
        state.postStaticInfoOutput = false;
    },

    //putStaticInfo
    putStaticInfoRequest(state) {
        state.putStaticInfoOutput = null;
    },
    putStaticInfoSuccess(state, output) {
        state.putStaticInfoOutput = true;
    },
    putStaticInfoFailure(state) {
        state.putStaticInfoOutput = false;
    },

    //putStaticInfoByStatus
    putStaticInfoByStatusRequest(state) {
        state.putStaticInfoByStatusOutput = null;
    },
    putStaticInfoByStatusSuccess(state, output) {
        state.putStaticInfoByStatusOutput = true;
    },
    putStaticInfoByStatusFailure(state) {
        state.putStaticInfoByStatusOutput = false;
    },

    //getStaticInfoByID
    getStaticInfoByIDRequest(state) {
    },
    getStaticInfoByIDSuccess(state, output) {
        state.getStaticInfoByIDOutput = output;
    },
    getStaticInfoByIDFailure(state) {
        state.getStaticInfoByIDOutput = false;
    },

    //getStaticInfoBySlug
    getStaticInfoBySlugRequest(state) {
    },
    getStaticInfoBySlugSuccess(state, output) {
        state.getStaticInfoBySlugOutput = output;
    },
    getStaticInfoBySlugFailure(state) {
        state.getStaticInfoBySlugOutput = false;
    },
};

export const staticInfos = {
    namespaced: true,
    state,
    actions,
    mutations
};